import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ContentPhotos = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
`;

export const PhotoAvatar = styled.div`
  flex: 0 0 14.5%;
  width: auto;
  height: 2em;
  box-sizing: border-box;
  border-radius: 99px;
  cursor: pointer;
  font-size: 26px;
  font-weight: 500;
  margin: 0.2em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  border: ${({ photoSelected, name }) => photoSelected === name ? "4px solid green" : ""};
  background-image: ${({ photo }) => (photo ? `url(${photo})` : "inherit")};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  &:hover {
    opacity: 0.8;
    border: 4px solid green;
  }
`

export const ContainerButtons = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-end;
  position: relative;
`;

export const CancelButton = styled.button`
  background: ${({ theme }) => theme.neutral.white};
  color: ${({ theme }) => theme.button.primary};
  font-size: 14px;
  font-weight: 500;
  border: 1px solid ${({ theme }) => theme.primary.purple};
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 30%;
  height: 43.21px;
  margin: 0.2em;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const SaveButton = styled.button`
  background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.neutral.white};
  font-size: 14px;
  font-weight: 500;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 30%;
  height: 43.21px;
  margin: 0.2em;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
